import { Route, Routes } from 'react-router'
import { observer } from 'mobx-react-lite'
import { AuthLayout } from 'entities/Auth/layout/AuthLayout'
import { RegisterPage } from 'pages/register/ui/registerPage'
import { RegisterMultiorgPage } from 'pages/register/pages/registerMultiorg'
import { RegisterRoutes } from 'pages/register/route/type'
import PageNotFound from 'pages/pageNotFound'

export const RegisterRouter = observer(() => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path={'/'} element={<RegisterPage />} />
      </Route>

      <Route path={`/${RegisterRoutes.multiorg}`} element={<RegisterMultiorgPage />} />

      <Route path='/*' element={<PageNotFound />} />
    </Routes>
  )
})
